module.exports = __webpack_public_path__ + "img/首页banner.7df1ac97.png";